import moment from 'moment';
import { useCallback, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import type { CalendarView } from 'voyager';

import { useDebouncedValue } from '@common/hooks';

type UseCalendarNavigationParams = {
  initialDate: string;
  form: UseFormReturn<any>;
};

export function useCalendarNavigation({ initialDate, form }: UseCalendarNavigationParams) {
  const [weekStartDate, setWeekStartDate] = useState<string>(() =>
    moment(initialDate).startOf('isoWeek').format('YYYY-MM-DD')
  );

  const [calendarView, setCalendarView] = useState<CalendarView>('week');

  const handleCalendarViewChange = useCallback(
    (view: CalendarView) => {
      setCalendarView(view);
      if (view === 'month') {
        const monthStart = moment(weekStartDate).startOf('month').format('YYYY-MM-DD');
        setWeekStartDate(monthStart);
      } else {
        const selected = form.getValues('date');
        const weekStart = moment(selected || weekStartDate)
          .startOf('isoWeek')
          .format('YYYY-MM-DD');
        setWeekStartDate(weekStart);
      }
    },
    [weekStartDate, form]
  );

  const debouncedWeekStartDate = useDebouncedValue(weekStartDate, 300);

  return {
    weekStartDate,
    setWeekStartDate,
    calendarView,
    setCalendarView,
    handleCalendarViewChange,
    debouncedWeekStartDate,
  };
}
